import fp from 'lodash/fp'
import { combine, withContext } from 'react-hooks-combine'
import { StoreContext } from 'store/context'
import { CURRENCY } from 'constants/currencies'

import CurrencyComponent from './component'

export const Currency = combine(
  withContext(
    'currency',
    StoreContext,
    fp.getOr(CURRENCY.USD, 'auth.loggedEntity.wallet.currency')
  )
)(CurrencyComponent)
